import React, { useState, useEffect, useRef } from "react";
import tw from "tailwind-styled-components";
import { useMutation } from "react-query";
import axios from "axios";
import Config from "../../Config";
import Loading from "../../Components/Loading";
import Table from "../../Components/Complaint/Table";
import {
  BoxContainer,
  BoxTitle,
  BoxHead,
  Underline,
  FilterTableWrapper,
  FilterWrapperWithSearch,
} from "../../Components/Styles/PageStyles";
import NotFoundModel from "../../Components/NotFoundModel";
import { useSelector } from "react-redux";
import ComplaintAction from "../../Components/Complaint/ComplaintAction";
import AddComplaint from "../../Components/Complaint/AddComplaint";
import SummaryCards from "../../Components/Complaint/SummaryCard";
import moment from "moment";
import { SummarySkeletonLoading } from "../../Components/SkeletonLoading";
import { toast } from "react-toastify";
import SearchFilterBox from "../../Components/SearchFilterBox";
import DateRange from "../../Components/DateRange";
import SideModal from "../../Components/SideModal";
import PropertiesFilterDropdown from "../../Components/PropertiesFilterDropdown";
import { IoFilter } from "react-icons/io5";
import FilterModal from "../../Components/Complaint/FilterModal";
import { AddBtn } from "../../Components/Styles/InputStyles";

const Complaints = () => {
  const searchOptions = [
    { label: "Mobile", value: 1 },
    { label: "Name", value: 2 },
  ];
  const [isFilterOpen, setIsFilterOpen] = useState(false);
  const [isComplaint, setIsComplaint] = useState(false);
  const [key, setKey] = useState("");
  const [isAddComplaint, setIsAddComplaint] = useState(false);
  const user = useSelector((state) => state.UserReducer.user);
  const [selectedData, setSelectedData] = useState("");
  const [filterValue, setFilterValue] = useState("");
  const [filter, setFilter] = useState("");
  const [apiData, setApiData] = useState();
  const [masterData, setMasterData] = useState();
  const properties = useSelector((state) => state.PropertyReducer.property);

  const [isFocused, setIsFocused] = useState(false);
  const [filterType, setFilterType] = useState("");
  const [searchQuery, setSearchQuery] = useState("");
  const [summary, setSummary] = useState(null);

  const initialLoadRef = useRef(false);

  const property = useSelector(
    (state) => state.SelectPropertyReducer.selectProperty
  );
  const [selectedProperty, setSelectedProperty] = useState(property);
  const [activeFilter, setActiveFilter] = useState("");
  const [propId, setPropId] = useState("all");
  const [activeTab, setActiveTab] = useState("1");
  const [selectedOption, setSelectedOption] = useState("selected");
  const [viewDetail, setViewDetail] = useState(false);
  const [startDate, setStartDate] = useState(
    moment().startOf("month").format("YYYY-MM-DD")
  );
  const [endDate, setEndDate] = useState(
    moment(new Date()).format("YYYY-MM-DD")
  );
  const [sideFilter, setSideFilter] = useState("");
  const [selectedStaff, setSelectedStaff] = useState(null);
  useEffect(() => {
    setPropId(property?.id || "all");
    setSelectedOption("selected");
  }, [property]);
  const btnRef = useRef(null);
  const initialValues = {
    name: "",
    propertyName: "",
    filterVal: filterValue,
    startDate: moment(new Date()).subtract(6, "days").format("YYYY-MM-DD"),
    endDate: moment(new Date()).format("YYYY-MM-DD"),
  };

  const getApiEndpoint = () => {
    if (activeTab === "1") {
      return `${Config.apiUrl}/complaint/web/list`;
    } else if (activeTab === "2") {
      return `${Config.apiUrl}/complaint/prop/web/list`;
    }
    return `${Config.apiUrl}/complaint/web/list`;
  };

  const fetchFunction = async ({ propId = propId }) => {
    const query = `&startDate=${startDate}&endDate=${endDate}&propId=${selectedProperty?.id}&filter=${filter}&s=${searchQuery}&t=${filterType}&typeFilter=${sideFilter}`;
    const apiEndpoint = getApiEndpoint();

    const response = await axios.get(
      `${apiEndpoint}?${query}`,
      {
        headers: {
          authorization: "Bearer" + " " + user.token,
          "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
        },
      }
    );
    return response.data;
  };

  const getSuccess = (res) => {
    if (res.isSuccess === false) {
      // console.error("API call failed:", res);
    } else {
      setApiData(res?.data);
      setMasterData(res?.data);
      setSummary(res?.stats);
      setIsFocused(true);
    }
  };

  const getError = (res) => {
    // console.error("API error:", res);
    toast.error("Failed to fetch complaints data");
  };

  const {
    isLoading,
    mutate: getListMutate,
    error,
    data,
    isRefetching,
  } = useMutation(fetchFunction, {
    onSuccess: getSuccess,
    onError: getError,
  });

  // useEffect(() => {
  //   const handler = setTimeout(() => {
  //     getListMutate({ propId });
  //   }, 50);

  //   return () => clearTimeout(handler);
  // }, [
  //   activeTab,
  //   startDate,
  //   endDate,
  //   propId,
  //   filter,
  //   selectedProperty,
  //   filterType,
  //   searchQuery,
  //   getListMutate,
  // ]);
useEffect(() => {
  const mockData = [
    {
      id: 1,
      createdAt: "2026-04-15T10:30:00",
      title: "Water Leakage",
      description: "Water is leaking from ceiling in bedroom",
      raisedByName: "Anurag",
      raisedByMobile: "9876543210",
      propertyName: "Sunshine Apartment",
      status: 1,
      staffName: null,
    },
    {
      id: 2,
      createdAt: "2026-04-14T09:00:00",
      title: "Electric Issue",
      description: "Switch board not working",
      raisedByName: "Rahul",
      raisedByMobile: "9123456780",
      propertyName: "Green Villa",
      status: 2,
      staffName: "Ramesh",
    },
    {
      id: 3,
      createdAt: "2026-04-13T08:20:00",
      title: "Lift Problem",
      description: "Lift stuck frequently",
      raisedByName: "Priya",
      raisedByMobile: "9988776655",
      propertyName: "Sky Tower",
      status: 3,
      staffName: "Suresh",
    },
  ];

  const mockSummary = {
    total: 3,
    pending: 1,
    assigned: 1,
    resolved: 1,
  };

  setApiData(mockData);
  setMasterData(mockData);
  setSummary(mockSummary);
  setIsFocused(true);
}, []);
  useEffect(() => {
    const savedStart = sessionStorage.getItem("complaints_startDate");
    const savedEnd = sessionStorage.getItem("complaints_endDate");

    if (savedStart && savedEnd) {
      setStartDate(savedStart);
      setEndDate(savedEnd);
    }
  }, []);

  // Save dates whenever they update
  useEffect(() => {
    if (startDate) sessionStorage.setItem("complaints_startDate", startDate);
    if (endDate) sessionStorage.setItem("complaints_endDate", endDate);
  }, [startDate, endDate]);

  const submitHandler = (values) => {
    const newValues = {
      startDate: moment(values.startDate).format("YYYY-MM-DD"),
      endDate: moment(values.endDate).format("YYYY-MM-DD"),
    };
    setFilter("");
    setFilterType("");
    setSearchQuery("");
    setStartDate(newValues.startDate);
    setEndDate(newValues.endDate);
    setSideFilter("")
  };

  const onSummaryBoxClick = (data) => {
    let filteredData;
    if (data === "P")
      //Security
      filteredData = masterData.filter((complains) => complains.status === 1);
    else if (data === "R")
      //Offline
      filteredData = masterData.filter((complains) => complains.status === 3);
    else if (data === "A")
      //Online
      filteredData = masterData.filter((complains) => complains.status === 2);
    else filteredData = masterData;
    setApiData(filteredData);
  };

  const applyFilter = (selectedOption) => {
    const newPropId = selectedOption === "all" ? "all" : property?.id;
    setPropId(newPropId);
  };

  const handleComplaintClose = () => {
    setIsComplaint(false);
  };

  const handleAddComplaintClose = () => {
    setIsAddComplaint(false);
  };

  //------- Add Complaint Model -------
  const addComplaintFunction = async (values) => {
    return await axios.post(`${Config.apiUrl}/complaint/admin/add`, values, {
      headers: {
        authorization: `Bearer ${user.token}`,
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
      },
    });
  };

  const addComplaintSuccess = (data) => {
    setIsAddComplaint(false);
    getListMutate({ propId });
    toast.success(data?.data?.msg || "Success");
  };

  const addComplaintError = (data) => {
    toast.error(data?.response?.data?.msg || "An Error Occured");
  };

  const { isLoading: addComplaintLoading, mutate: addComplaintMutate } =
    useMutation(addComplaintFunction, {
      onSuccess: addComplaintSuccess,
      onError: addComplaintError,
    });

  //------- Update Complaint Model -------
  const updateComplaintFunction = async (values) => {
    return await axios.post(
      `${Config.apiUrl}/complaint/status/update`,
      values,
      {
        headers: {
          "Content-Type": "application/json",
          authorization: `Bearer ${user.token}`,
        },
      }
    );
  };

  const updateComplaintSuccess = (data) => {
    setIsComplaint(false);
    getListMutate({ propId });
    toast.success(data?.data?.msg || "Success");
  };

  const updateComplaintError = (data) => {
    toast.error(data?.response?.data?.msg || "An Error Occured");
  };

  const { isLoading: updateComplaintLoading, mutate: updateComplaintMutate } =
    useMutation(updateComplaintFunction, {
      onSuccess: updateComplaintSuccess,
      onError: updateComplaintError,
    });

  //------- Assign Complaint Model -------
  const assignComplaintFunction = async (values) => {
    return await axios.post(`${Config.apiUrl}/complaint/assign`, values, {
      headers: {
        "Content-Type": "application/json",
        authorization: `Bearer ${user.token}`,
      },
    });
  };

  const assignComplaintSuccess = (data) => {
    setIsComplaint(false);
    getListMutate({ propId });
    toast.success(data?.data?.msg || "Success");
  };

  const assignComplaintError = (data) => {
    toast.error(data?.response?.data?.msg || "An Error Occured");
  };

  const { isLoading: assignComplaintLoading, mutate: assignComplaintMutate } =
    useMutation(assignComplaintFunction, {
      onSuccess: assignComplaintSuccess,
      onError: assignComplaintError,
    });

  const handleFilterChange = (values) => {
    setFilterType(values.filterType);
    setSearchQuery(values.searchQuery);
  };

  const handleClearFilters = () => {
    setFilterType("");
    setSearchQuery("");
    setActiveFilter("");
    setSideFilter("")
    setSelectedStaff(null)
  };

  const handlePropertySelect = (property) => {
    setSelectedProperty(property);
  };

  const handleTabChange = (tab) => {
    setActiveTab(tab);
    setFilterType("");
    setSearchQuery("");
    setFilter("");
    setActiveFilter("");
    setSideFilter("")
    setSelectedStaff(null)
  };

  const onApplyFilter = (value, label) => {
    setSideFilter(value)
    setFilterType("");
    setSearchQuery("");
    //setFilter(value);
    setActiveFilter("1");
    setIsFilterOpen(false);
    const handler = setTimeout(() => {
      getListMutate({ propId });
    }, 100);

    return () => {
      clearTimeout(handler);
    };
  };

  const handleFilterClose = () => {
    setSelectedStaff("");
    setActiveFilter("");
    setSideFilter("")
    setFilterType("");
    setSearchQuery("");
    //setFilter(value);
    setIsFilterOpen(false);
    const handler = setTimeout(() => {
      getListMutate({ propId });
    }, 100);

    return () => {
      clearTimeout(handler);
    };
  };
  const staffs = data?.staffs?.map(staff => ({
    label: staff.name,
    value: staff.id,
  })) || [];

  return (
    <BoxContainer>
      <BoxHead>
        <BoxTitle className="!mb-0 whitespace-nowrap">
          Complaints
          <Underline />
        </BoxTitle>
        <div className="flex space-x-4 md:ml-auto">
          {/* <AddBtn
            type="button"
            onClick={() => {
              setKey(moment().unix());
              setIsAddComplaint(true);
            }}
          >
            {"Add Complaint"}
          </AddBtn> */}
        </div>
      </BoxHead>
      {/* <FloorTabs>
        <FloorTab
          key="tenant"
          onClick={() => handleTabChange('1')}
          $active={activeTab === "1"}
        >
          Tenant Complaints
        </FloorTab>
        <FloorTab
          key="property"
          onClick={() => handleTabChange('2')}
          $active={activeTab === "2"}
        >
          Property Complaints
        </FloorTab>
      </FloorTabs> */}

      {/* {isFilterOpen && (
        <FilterPopup
          isOpen={isFilterOpen}
          onClose={() => setIsFilterOpen(false)}
          applyFilter={applyFilter}
          setIsFilterOpen={setIsFilterOpen}
          selectedOption={selectedOption}
          setSelectedOption={setSelectedOption}
          name={property?.name}
        />
      )} */}

      <SideModal
        isOpen={isComplaint}
        onClose={() => setIsComplaint(false)}
      >
        <ComplaintAction
          setIsComplaint={setIsComplaint}
          isComplaint={isComplaint}
          handleClose={handleComplaintClose}
          setSelectedData={selectedData}
          selectedData={selectedData}
          assignComplaintLoading={assignComplaintLoading}
          assignComplaintMutate={assignComplaintMutate}
          updateComplaintMutate={updateComplaintMutate}
          updateComplaintLoading={updateComplaintLoading}
          activeTab={activeTab}
        />
      </SideModal>

      <SideModal
        isOpen={isAddComplaint}
        onClose={() => setIsAddComplaint(false)}
      >
        <AddComplaint
          key={key}
          setIsAddComplaint={setIsAddComplaint}
          isAddComplaint={isAddComplaint}
          handleClose={handleAddComplaintClose}
          addComplaintLoading={addComplaintLoading}
          addComplaintMutate={addComplaintMutate}
        />
      </SideModal>
      <SideModal isOpen={isFilterOpen} onClose={() => setIsFilterOpen(false)}>
        <FilterModal
          setIsFilterOpen={setIsFilterOpen}
          onApplyFilter={onApplyFilter}
          selectedData={selectedData}
          handleClose={handleFilterClose}
          staffs={staffs}
          selected={null}
          setSelectedStaff={setSelectedStaff}
          selectedStaff={selectedStaff}
        />
      </SideModal>

      {(isLoading || isRefetching) && !isFocused && (
        <SummarySkeletonLoading count={3} />
      )}

      {isFocused && summary && (
        <>
          <SummaryCards summaryData={summary} onClick={onSummaryBoxClick} />
          <FilterTableWrapper>
            <FilterWrapperWithSearch>
              <div className="flex flex-col md:flex-row md:items-center lg:space-x-4 gap-4">
                {activeTab === "1" &&
                  <SearchFilterBox
                    options={searchOptions}
                    handleFilterChange={handleFilterChange}
                    handleClearFilters={handleClearFilters}
                  />}
                <DateRange
                  submitHandler={submitHandler}
                  defaultLabel={
                    moment(startDate).format("DD MMM yyyy") +
                    " - " +
                    moment(endDate).format("DD MMM yyyy")
                  }
                />
              </div>
              <div className="w-full md:w-auto flex justify-between gap-4">
                <PropertiesFilterDropdown
                  properties={properties}
                  selectedProperty={selectedProperty}
                  onPropertySelect={handlePropertySelect}
                  placeholder="Select Property"
                  className="min-w-[200px] w-full md:w-[220px]"
                />
                <div className="relative">
                  <FilterBtn
                    ref={btnRef}
                    type="button"
                    title="Category Filter"
                    onClick={() => setIsFilterOpen((v) => !v)}
                    className={`flex items-center border whitespace-nowrap border-gray-300 justify-center rounded-md px-4 cursor-pointer bg-white hover:bg-gray-200 h-10 text-sm ml-auto}`}
                  >
                    <IoFilter size={14} color="#9CA3AF" />
                  </FilterBtn>
                  {/* Yellow dot when filter is applied */}
                  {activeFilter && (
                    <span className="absolute -top-1 -right-1 w-3 h-3 bg-yellow-400 rounded-full"></span>
                  )}
                </div>
              </div>
            </FilterWrapperWithSearch>

            {/* {!error && !isLoading && data && ( */}
            {apiData &&(
              <TableWrapper>
                <Table
                  apiData={error ? [] : apiData}
                  setSelectedData={setSelectedData}
                  selectedData={selectedData}
                  setViewDetail={setViewDetail}
                  userType={user.userType}
                  setIsComplaint={setIsComplaint}
                />
                {(error || apiData?.length === 0) && !isLoading && (
                  <NotFoundModel msg={"All good! No complaint at the moment."} />
                )}
              </TableWrapper>
            )}
          </FilterTableWrapper>

          {(isLoading || isRefetching) && <Loading />}
        </>
      )}
    </BoxContainer>
  );
};

const FloorTabs = tw.div`flex overflow-x-auto bg-white rounded-md my-4 border-b`;
const FloorTab = tw.button`
  ${(p) =>
    p.$active
      ? " text-primary-color border-b-2 border-b-primary-color bg-cyan-50 "
      : " text-gray-700 "} 
   px-5 py-3  cursor-pointer font-medium transition-all duration-200 whitespace-nowrap text-sm
`;
const TableWrapper = tw.h1`mt-4 bg-white rounded-md `;
const FilterBtn = tw.button``;
export default Complaints;